import { config } from './config';

const storageKey = 'COMFORT_BIDS_DESIGN_OPT_OUT_KEY'; // mirrored in React
const targetLocation = window.parent.location;

type UrlParams = { networkPointId?: number; comfortBidId?: number };

function createNewUrl(params: UrlParams = {}) {
    if (params.comfortBidId)
        return `${config.appBaseUrl}/transport/auctions/comfort-bids/edit/${params.comfortBidId}`;

    if (params.networkPointId)
        return `${config.appBaseUrl}/transport/auctions/comfort-bids/create?networkPointId=${params.networkPointId}`;

    return `${config.appBaseUrl}/transport/auctions/comfort-bids/create`;
}

function goToNewDesign(params: UrlParams = {}) {
    targetLocation.replace(createNewUrl(params));
}

export const migratedComfortBids = {
    isNewDesignActive: localStorage.getItem(storageKey) === null,
    activate(params: UrlParams = {}) {
        console.log('activate!!!');
        localStorage.removeItem(storageKey);
        goToNewDesign(params);
    },
    goToNewDesign,
    createNewUrl
};
